// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageDate_date__oG9jc {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #8E8E93;
  margin-left: 2px;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/MessageDate/MessageDate.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AACF","sourcesContent":[".date {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  color: #8E8E93;\n  margin-left: 2px;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"date": `MessageDate_date__oG9jc`
};
export default ___CSS_LOADER_EXPORT___;
